export const ROOM_TYPES = [
  'Bedroom','Kitchen','Living Room','Dining Room','Bathroom',
  'Office / Study','Laundry Room','Mudroom','Garage',
  'Outdoor / Patio','Entryway / Foyer','Hallway','Basement','Attic','Other'
]

export const FLOOR_LEVELS = ['Basement','1st Floor','2nd Floor','3rd Floor','Attic','All Floors']

export const ITEM_STATUSES = ['Considering','Shortlisted','Purchased','Installed','Rejected']

export const EXPENSE_TYPES = ['Insurance','Property Tax','HOA','Mortgage','Utilities','Maintenance','Other']

export const PAYMENT_PERIODS = ['Monthly','Quarterly','Semi-Annual','Annual','One-Time']

export const STATUS_CONFIG = {
  Considering: { color: '#6B7280', bg: '#F3F4F6' },
  Shortlisted:  { color: '#1D4ED8', bg: '#EFF6FF' },
  Purchased:    { color: '#B45309', bg: '#FFFBEB' },
  Installed:    { color: '#15803D', bg: '#F0FDF4' },
  Rejected:     { color: '#B91C1C', bg: '#FEF2F2' },
}

export const DEFAULT_CATEGORIES = [
  { key: 'Finish',    emoji: '🎨', color: '#7C3AED', active: true,  custom: false },
  { key: 'Appliance', emoji: '⚡', color: '#0369A1', active: true,  custom: false },
  { key: 'Furniture', emoji: '🪑', color: '#92400E', active: true,  custom: false },
  { key: 'Decor',     emoji: '✨', color: '#BE185D', active: true,  custom: false },
  { key: 'Fixture',   emoji: '💡', color: '#0F766E', active: false, custom: false },
  { key: 'Material',  emoji: '🪨', color: '#6B5E47', active: false, custom: false },
]

export const CAT_COLORS = [
  '#7C3AED','#0369A1','#92400E','#BE185D','#0F766E',
  '#6B5E47','#B45309','#15803D','#1D4ED8','#B91C1C'
]

export const CATEGORY_EMOJIS = [
  '🎨','⚡','🪑','✨','💡','🪨','🔧','🛁','🪟','🚪',
  '🪴','🛏️','🖼️','🪞','🏠','🌿','💧','🔌','🪵','🧱',
  '📦','🎯','🏷️','🔲'
]

export const ANNUAL_MULTIPLIER = {
  Monthly: 12,
  Quarterly: 4,
  'Semi-Annual': 2,
  Annual: 1,
  'One-Time': 0,
}
